var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 5,
    viewBox: "0 0 4 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5C3.99943 2.60635 3.97361 2.71125 3.92441 2.80708C3.87521 2.90292 3.80386 2.98728 3.71556 3.05406L1.44889 4.80788C1.31243 4.91037 1.148 4.97486 0.974341 4.99401C0.800681 5.01316 0.624774 4.9862 0.466667 4.9162C0.329256 4.85942 0.212184 4.76678 0.129432 4.64932C0.0466808 4.53187 0.0017481 4.39457 9.7849e-08 4.25383L5.57822e-07 0.746175C0.0017486 0.60543 0.0466814 0.46813 0.129433 0.350676C0.212184 0.233221 0.329257 0.140576 0.466667 0.0838037C0.624775 0.0138036 0.800682 -0.0131582 0.974342 0.00599206C1.148 0.0251419 1.31243 0.0896327 1.44889 0.192115L3.71556 1.94594C3.80386 2.01272 3.87521 2.09709 3.92441 2.19292C3.97361 2.28875 3.99943 2.39365 4 2.5Z",
    fill: "#868F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.9bec484249dfb15667bee61bf5120363.svg";
export { ForwardRef as ReactComponent };